<template lang="pug">

	form
		div.form-group
			
			label.required Nome:
			
			input.form-control.form-control-sm(type="text", v-model="nome", name="nome", v-validate="'required'")
			
			input-errors(name="nome")

		div.form-group

			label.required Cor:

			color-palette(v-model="cor", name="cor", v-validate="'required'", @input="onCorChange")

			input-errors(name="cor")

		div.form-group

			label.required Vetorização:

			div
				draw-button.col-md-12(@drawComplete="onGeometriaVetorizada", :drawTool="drawTool")

				div.invalid-field(v-show="validacaoExecutada && (!this.geometrias || this.geometrias.length === 0)") 
					| É necessário vetorizar ao menos uma geometria.

		ul.list-group(v-show="geometrias && geometrias.length")

			li.list-group-item(
					v-for="(geom, index) in geometrias", 
					@mouseenter="onGeometriaMouseEnter(index)",
					@mouseleave="onGeometriaMouseLeave(index)")
				
				|  {{ tipoGeometria.nome + ' ' + (index + 1) }}

				i.action-icon.mdi.mdi-window-close(@click="removerGeometria(index)")

		
		div.row
			div.col-12.mt-2
					
				button.btn.btn-outline-secondary.btn-sm(type="button", @click="cancelar()")
					i.mdi.mdi-close
					|  Cancelar

				button.btn.btn-primary.btn-sm.float-right(type="button", 
						@click="adicionarCamada()")
					i.mdi.mdi-check
					|  Adicionar
					

</template>

<script>

import L from 'leaflet';
import ColorPalette from '@/components/utils/ColorPalette';
import InputErrors from '@/components/utils/InputErrors';
import DrawButton from '@/components/utils/DrawButton';
import TipoGeometria from '@/models/tipoGeometria';
import Estilo from '@/models/estilo';
import DrawUtils from '@/utils/drawUtils';
import { mapMutations } from 'vuex';

const COR_PADRAO = DrawUtils.DEFAULT_COLOR;
const COR_DESTAQUE = '#FF0000';

export default {
	
	name: 'AdicaoCamadaGeometria',

	components: { ColorPalette, InputErrors, DrawButton },

	props: {
		tipoGeometria: {
			tipe: Object,
			required: true
		}
	},

	data () {
		return {
			geometrias: [],
			nome: '',
			style: null,
			styleDestaque: null,
			cor: null,
			validacaoExecutada: false,
			drawTool: DrawUtils.POLYGON_TOOL
		};
	},

	created () {

		this.configureStyle();
		
		var estilo = Estilo.criarEstiloCamadaUsuario(COR_DESTAQUE, this.tipoGeometria);
		this.styleDestaque = Estilo.toMapStyle(estilo, true);

		if (this.tipoGeometria.codigo === TipoGeometria.POLIGONO.codigo) {
			
			this.drawTool = DrawUtils.POLYGON_TOOL;

		} else if (this.tipoGeometria.codigo === TipoGeometria.LINHA.codigo) {

			this.drawTool = DrawUtils.POLYLINE_TOOL;

		} else if (this.tipoGeometria.codigo === TipoGeometria.PONTO.codigo) {

			this.drawTool = DrawUtils.CIRCLEMARKER_TOOL;
		}
	},

	methods: {

		onGeometriaVetorizada (data) {

			this.geometrias.push(data);
			data.layer.setStyle(this.style);
		},

		removerGeometria (index) {

			var geometria = this.geometrias[index];
			this.geometrias.splice(index, 1);
			this.$mapa.removeLayer(geometria.layer);
		},

		configureStyle () {

			var cor = this.cor || COR_PADRAO;
			var estilo = Estilo.criarEstiloCamadaUsuario(cor, this.tipoGeometria);
			this.style = Estilo.toMapStyle(estilo, true);
		},

		onCorChange () {

			this.configureStyle();

			if (!this.geometrias || this.geometrias.length === 0) return;

			for (let geometria of this.geometrias) {

				geometria.layer.setStyle(this.style);
			}
		},

		onGeometriaMouseEnter (index) {

			this.geometrias[index].layer.setStyle(this.styleDestaque);
		},

		onGeometriaMouseLeave (index) {

			this.geometrias[index].layer.setStyle(this.style);
		},

		removerGeometriasMapa () {

			if (!this.geometrias || !this.geometrias.length) return;

			for (let geometria of this.geometrias) {
				this.$mapa.removeLayer(geometria.layer);
			}
		},

		adicionarGeometriasMapa () {

			if (!this.geometrias || !this.geometrias.length) return;

			for (let geometria of this.geometrias) {
				this.$mapa.addLayer(geometria.layer);
			}
		},

		limparCampos () {

			this.cor = null;
			this.nome = null;
			this.removerGeometriasMapa();
			this.geometrias = [];
			this.configureStyle();

			this.$nextTick().then(() => {
				this.validacaoExecutada = false;
				this.$validator.cleanErrors();
			});
		},

		cancelar () {
			
			this.limparCampos();
			this.$emit('limpar');
		},

		adicionarCamada () {

			this.$emit('limpar');

			this.validacaoExecutada = true;

			if (!this.geometrias || this.geometrias.length === 0) {

				this.$validator.validateAll();
				return;
			}

			this.$validator.validateAll().then((result) => {
					
				var layers = _.map(this.geometrias, 'layer');
				var layerGroup = L.layerGroup(layers);

				if (result) {
					
					this.$emit('adicionarCamada', {
						nome: this.nome,
						geoJson: layerGroup.toGeoJSON(),
						cor: this.cor
					});

					this.limparCampos();
				}
			});
		},

		...mapMutations([
			'adicionarCamadaUsuario',
			'ativarCamada'
		])
	}
};

</script>

<style lang="scss" scoped>

	ul.list-group {
		margin-top: 10px;
		margin-bottom: 20px;

		li.list-group-item {
			border-left: none;
			border-right: none;
			padding: 6px 5px;
			font-size: 14px;
			color: #777777;
			cursor: default;

			&:hover {
				color: #333;
			}
		}

		i {
			display: block;
			float: right;
		}
	}

</style>


// WEBPACK FOOTER //
// AdicaoCamadaGeometria.vue?0c910e44